export const StorageKeys = {
	Stores: {
		AUTH_STORE: 'AUTH_STORE',
		ACTIVE_USER_STORE: 'ACTIVE_USER_STORE',
		COMPANY_SETTINGS_STORE: 'COMPANY_SETTINGS_STORE',
		APP_INFO_STORE: 'APP_INFO_STORE',
	},
	GlobalKeys: {
		ENVIRONMENT: 'ENVIRONMENT',
		ROUTE_HISTORY: 'ROUTE_HISTORY',
		LANGUAGE: 'LANGUAGE',
		VERSION_LOG: 'VERSION_LOG',
		VERSION_CHECK_INTERVAL_SEC: 'VERSION_CHECK_INTERVAL_SEC',
		PWA_INSTALLED: 'PWA_INSTALLED',
		INDEXED_DB_VERSION: 'INDEXED_DB_VERSION',
		SW_VERSION: 'SW_VERSION',
		COMPANY_MANIFEST: 'COMPANY_MANIFEST',
	},
	AuthKeys: {
		KeyAPIUri: 'Auth.APIUri',
		ActiveUserId: 'ActiveUserId',
		REDIRECTED: 'REDIRECTED',
	},
	SignKeys: {
		SEQUENTIAL_SIGNING: 'SEQUENTIAL_SIGNING',
	},
	Dev: {
		DEV_MODE: 'DEV_MODE',
	},
	Logging: {
		SENTRY_DEBUG: 'SENTRY_DEBUG',
		SIGNAL_STORE_DEBUG: 'SIGNAL_STORE_DEBUG',
	},
} as const;

export const PersistentStorageKeys = [StorageKeys.GlobalKeys.VERSION_LOG, StorageKeys.GlobalKeys.LANGUAGE, StorageKeys.Dev.DEV_MODE];

/**
 * Example of usage:
 * 1. to strictly type the key (from the whole StorageKeys):
 * const t2: StorageKeyType = StorageKeys.VersionKeys.FRONT_END; // Valid for all categories
 * const t3: StorageKeyType = StorageKeys.AuthKeys.ACCESS_TOKEN; // Valid for all categories
 *
 * 2. to strictly type the key and the category:
 * const t1: StorageKeyType<'AuthKeys'> = StorageKeys.AuthKeys.ACCESS_TOKEN; // Valid but only for AuthKeys category
 *
 * 3. Error cases:
 * const t4: StorageKeyType = '1'
 */
type AllKeys = keyof typeof StorageKeys;
type AllValues = (typeof StorageKeys)[AllKeys][keyof (typeof StorageKeys)[AllKeys]];
export type StorageKeyType<T extends AllKeys = AllKeys> = T extends AllKeys ? (typeof StorageKeys)[T][keyof (typeof StorageKeys)[T]] : AllValues;

export function getAllStorageKeys(): StorageKeyType[] {
	return Object.values(StorageKeys).reduce((acc, val) => {
		return acc.concat(Object.values(val));
	}, []);
}
